import * as React from 'react';
import {classes, style} from 'typestyle';
import {centerCenter} from 'csstips';
import {px} from 'csx';
import {CSSGlobalValues, CSSLength, CSSPercentage, CSSValue} from 'typestyle/lib/types';
import {transitionQuickEase} from '../theme/transition';

export interface ButtonCircleProps {
  onClick?(event: React.MouseEvent<any>): void;
  className?: string;
  style?: any;
  size?: CSSValue<'auto' | CSSLength | CSSPercentage | CSSGlobalValues>
}

export class ButtonCircle extends React.Component<ButtonCircleProps, any> {
  render() {
    const { children, className, onClick, size = px(32), style = {} } = this.props;

    const innerStyle = {
      ...style,
      width: size,
      height: size,
      borderRadius: size
    };

    return (
      <div role="button" style={innerStyle} className={classes(className, ButtonCircle.styles.container)} onClick={onClick}>
        {children}
      </div>
    )
  }

  static styles = {
    container: style({
      ...centerCenter,
      display: 'inline-flex',
      background: 'transparent',
      appearance: 'none',
      '-webkit-appearance': 'none',
      '-moz-appearance': 'none',
      border: 'none',
      cursor: 'pointer',
      transition: `all ${transitionQuickEase}`
    })
  }
}